import { DeviceChannelData } from "../../../types/device";
import { makeAlarmsListGroupsComponent } from "../Lists";

export const ManageAlarmsListGroups = makeAlarmsListGroupsComponent<DeviceChannelData>();
